import {ChangeDetectorRef, Component, HostBinding, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {fadeAnimation} from "@shared/animations/fade.animation";

@Component({
  selector: 'page-loader',
  templateUrl: './page-loader.component.html',
  styleUrls: ['./page-loader.component.scss'],
  animations: [
    fadeAnimation
  ],
})
export class PageLoaderComponent implements OnInit, OnChanges {

  @Input() loading: boolean;
  @Input() topPaddingClass = 'medium'; // small|medium
  @HostBinding('class.hide') loaded = false;
  loadingGif: string;

  constructor(
    private cdRef: ChangeDetectorRef
  ) {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.loading.currentValue === false) {
      this.loaded = true;
      this.cdRef.detectChanges();
    } else {
      this.loaded = false;
    }
  }

  ngOnInit(): void {
  }

}
